import { render, staticRenderFns } from "./LiveClock.vue?vue&type=template&id=68657c59&"
import script from "./LiveClock.vue?vue&type=script&lang=js&"
export * from "./LiveClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports